/* eslint-disable */
import { IEvent } from "./interfaces";
import { isTwin } from "~/util/review";

export function getSignal(data: IEvent): string {
	const poiData = data?.data?.poi?.poiagg || { typeId: 0, id: 0 };

	return `${poiData.typeId}_${poiData.id}`;
}

export function getTypePoi(isEventCorrected: boolean, count: number): string {
	let typePoi = "";

	if (count <= 1) {
		typePoi = isEventCorrected ? "corrected" : "suggested";
	} else {
		typePoi = isEventCorrected ? "correctedLine" : "suggestedLine";
	}

	return typePoi;
}

export function getFirmLogObj(event: IEvent, isEventCorrected: boolean, count: number) {
	return {
		rating_layout: 0,
		source: "recenze-notification",
		signal: getSignal(event),
		typePoi: getTypePoi(isEventCorrected, count),
		section: "reviews",
		position: "top",
		sourcePoi: event.data.poi.source,
		typeid: event.data.poi.poiagg.typeId,
		firmTwin: isTwin(event.data.poi.poiagg) ? 1 : 0,
	};
}

export function sendAnalytics(action: string, data: IEvent, opts: any) {
	Mapy.getComponent("logger").log(action, {
		signal: getSignal(data),
		section: "suggestionDashboard",
		...opts,
	});
}
